"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Image = void 0;

var _react = _interopRequireWildcard(require("react"));

var _get = _interopRequireDefault(require("lodash/get"));

var _coreMatchMedia = _interopRequireDefault(require("@legacy-vfuk/core-match-media"));

var _styledComponents = require("styled-components");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var Image = /*#__PURE__*/function (_PureComponent) {
  _inherits(Image, _PureComponent);

  var _super = _createSuper(Image);

  function Image() {
    _classCallCheck(this, Image);

    return _super.apply(this, arguments);
  }

  _createClass(Image, [{
    key: "getSourceSetValue",
    value: function getSourceSetValue(src, size) {
      if (!src) return '';
      var resolutionMap = {
        x1: '',
        x2: '2x',
        x3: '3x'
      };
      return "".concat(src, " ").concat(resolutionMap[size]).trim();
    }
  }, {
    key: "getSource",
    value: function getSource(breakpoint) {
      var _this = this;

      var currentBreakpoint = Image.breakpoints.indexOf(breakpoint);
      var sourceSet = (0, _get["default"])(this.props[breakpoint], 'srcSet');
      var src = (0, _get["default"])(this.props[breakpoint], 'src');
      var nextBreakpoint = Image.breakpoints[currentBreakpoint - 1]; // If neither then go the next breakpoint

      if (!sourceSet && !src && nextBreakpoint) {
        return this.getSource(nextBreakpoint);
      } // If the breakpoint has no sourceSet but has src


      if (!sourceSet && src) return src;

      if (sourceSet) {
        return Object.keys(sourceSet).map(function (size) {
          return _this.getSourceSetValue(sourceSet[size], size);
        }).filter(Boolean).join(', ');
      }

      return null;
    }
  }, {
    key: "getFallbackImage",
    value: function getFallbackImage() {
      var breakpoint = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'xl';
      var currentBreakpoint = Image.breakpoints.indexOf(breakpoint);
      var imageObj = (0, _get["default"])(this.props, "".concat(breakpoint));
      var nextBreakpoint = Image.breakpoints[currentBreakpoint + 1];
      if (imageObj) return imageObj; // If no image object found for current breakpoint try next size up

      if (nextBreakpoint) {
        return this.getFallbackImage(nextBreakpoint);
      }
    }
  }, {
    key: "getBreakpointFallback",
    value: function getBreakpointFallback(breakpoint) {
      var fallback = this.getFallbackImage();
      var imageData = this.props[breakpoint];

      if (!(imageData !== null && imageData !== void 0 && imageData.src)) {
        return {
          src: fallback.src,
          width: (fallback === null || fallback === void 0 ? void 0 : fallback.width) || '100%',
          height: (fallback === null || fallback === void 0 ? void 0 : fallback.height) || 'auto'
        };
      }

      return {
        src: imageData === null || imageData === void 0 ? void 0 : imageData.src,
        width: (imageData === null || imageData === void 0 ? void 0 : imageData.width) || '100%',
        height: (imageData === null || imageData === void 0 ? void 0 : imageData.height) || 'auto'
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var fallbackImageObj = this.getFallbackImage();
      return /*#__PURE__*/_react["default"].createElement("picture", null, Image.breakpoints.map(function (breakpoint, index) {
        var srcSet = _this2.getSource(breakpoint);

        if (!srcSet) return;
        return /*#__PURE__*/_react["default"].createElement("source", {
          media: "(min-width: ".concat(_this2.props.theme.breakpoints[breakpoint], "px)"),
          srcSet: srcSet,
          key: index
        });
      }), fallbackImageObj ? Image.breakpoints.map(function (breakpoint, index) {
        return /*#__PURE__*/_react["default"].createElement(_coreMatchMedia["default"], {
          key: index,
          breakpoint: breakpoint
        }, /*#__PURE__*/_react["default"].createElement("img", _extends({
          title: _this2.props.title,
          alt: _this2.props.alt
        }, _this2.getBreakpointFallback(breakpoint))));
      }) : null);
    }
  }]);

  return Image;
}(_react.PureComponent);

exports.Image = Image;
Image.breakpoints = ['xl', 'lg', 'md', 'sm'];
Image.displayName = "Image";

var _default = (0, _styledComponents.withTheme)(Image);

exports["default"] = _default;
//# sourceMappingURL=Image.js.map